module.exports = __webpack_public_path__ + "static/img/M-2.1bfe593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-2.png
// module id = 159h
// module chunks = 0